import { createAuthClient } from "better-auth/react";
import { apiBaseUrl, tokenStore } from "./platform";

/**
 * Better Auth client. On the web the session cookie does the work; in native apps the
 * server returns a bearer token (header `set-auth-token`) that we store and send back.
 */
export function createHexlingAuthClient(baseUrl = apiBaseUrl()) {
  return createAuthClient({
    baseURL: baseUrl || window.location.origin,
    basePath: "/api/auth",
    fetchOptions: {
      auth: { type: "Bearer", token: () => tokenStore.get() ?? undefined },
      onSuccess: (ctx) => {
        const token = ctx.response.headers.get("set-auth-token");
        if (token) tokenStore.set(token);
      },
    },
  });
}

export type AuthClient = ReturnType<typeof createHexlingAuthClient>;

export interface Me {
  user: { id: string; email: string; name: string; role: string } | null;
  isStaff?: boolean;
  permissions?: string[];
}
